import { MAIN_CURRENCY } from '@copmer/frc-api-types';

import { InputGroup } from '@/ui-lib/form/inputgroup';
import { Select } from '@/ui-lib/select';

import { useCalculatorCurrencyContext } from './currency-context';

export const CurrencyDropdown = ({ noLabel, isMobileHeader }: { noLabel?: boolean; isMobileHeader?: boolean }) => {
    const { currency, setCurrency, currencies, isLoading, hasCurrencies } = useCalculatorCurrencyContext();

    const select = (
        <Select
            value={currency}
            onChange={(value: string | null) => setCurrency(value ?? MAIN_CURRENCY)}
            options={currencies}
            loading={isLoading}
            placeholder="Select Currency"
            noClear
            className="w-16"
            menuPortalTarget={
                isMobileHeader
                    ? typeof document !== 'undefined'
                        ? (document.querySelector('#header-extra') as HTMLElement)
                        : undefined
                    : null
            }
            disabled={isLoading || !hasCurrencies}
            color="grey"
            mode="dark"
        />
    );

    if (noLabel) {
        return select;
    }

    return <InputGroup label="Currency">{select}</InputGroup>;
};
